import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { PRODUCT_IMAGE, heroStats } from '../../data/content';
const trustPoints = ['Instant Digital Access', 'One-Time Payment', 'Lifetime Access', '7-Day Guarantee'];
export function Hero() {
  return <section className="relative overflow-hidden bg-ink-900 px-5 pb-14 pt-9 sm:px-8 sm:pb-20 sm:pt-12" data-id="element-198" data-mp="hvh2onuimc17">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-64 bg-teal-500/10 blur-3xl" aria-hidden="true" data-id="element-199" data-mp="mutw5rfw6hcr" />
      <div className="relative mx-auto flex max-w-6xl flex-col items-center lg:flex-row lg:items-center lg:gap-14" data-id="element-200" data-mp="qtt13c1mie47">
        <div className="w-full lg:w-[54%]" data-id="element-201" data-mp="voory8v4ivfq">
          <p className="text-center font-display text-sm font-bold uppercase tracking-[0.32em] text-teal-300 lg:text-left" data-id="element-202" data-mp="10lp1itr6mgbl">
            Master System of TRT™
          </p>

          <h1 className="mt-4 text-center font-display text-[34px] font-bold uppercase leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-left lg:text-[56px]" data-id="element-203" data-mp="1ajd5maaoh06f">
            Make TRT Decisions in
            <span className="mt-2 block text-teal-300" data-id="element-204" data-mp="4oznm8w8cyis">Under 5 Minutes</span>
          </h1>

          <p className="mx-auto mt-5 max-w-xl text-center text-[15px] leading-relaxed text-white/75 sm:text-lg lg:mx-0 lg:text-left" data-id="element-205" data-mp="3vur7wrnbtgxo">
            Use step-by-step clinical algorithms to know whether to start, adjust, postpone, or
            discontinue TRT — without reviewing multiple guidelines during every consultation.
          </p>

          <p className="mt-5 text-center font-display text-lg font-bold uppercase tracking-[0.14em] text-white sm:text-xl lg:text-left" data-id="element-206" data-mp="ngin45r1pug2">
            Master TRT without the guesswork.
          </p>
        </div>

        <div className="mt-8 w-full lg:mt-0 lg:w-[46%]" data-id="element-207" data-mp="eme05xf1935t">
          <img src={PRODUCT_IMAGE} alt="Master System of TRT — six clinical volumes shown on print, tablet, and phone" className="mx-auto w-full max-w-md drop-shadow-[0_25px_45px_rgba(0,0,0,0.55)] lg:max-w-none" width={1080} height={1080} data-id="element-208" data-mp="1b5bo4gmiyshj" />
        </div>
      </div>

      <div className="relative mx-auto mt-8 grid max-w-4xl grid-cols-2 gap-2 sm:mt-10 sm:grid-cols-4 sm:gap-3" data-id="element-209" data-mp="35kh1wh169ys8">
        {heroStats.map(stat => <div key={stat.label} className="flex flex-col items-center justify-start rounded-xl border border-white/10 bg-ink-800/70 px-2 py-3 text-center" data-id="element-210" data-mp="2vuxhv81q3yvs">
            <span className="font-display text-2xl font-bold text-teal-300 sm:text-3xl" data-id="element-211" data-mp="2muiwk8orejsa">
              {stat.value}
            </span>
            <span className="mt-1 text-[10px] font-bold uppercase leading-tight tracking-[0.1em] text-white/60 sm:text-[11px]" data-id="element-212" data-mp="27ybcr9h9jkdj">
              {stat.label}
            </span>
          </div>)}
      </div>

      <div id="hero-cta" className="relative mx-auto mt-8 max-w-md" data-id="element-213" data-mp="676n2iyw4tvu">
        <CtaButton label="Get the Master System of TRT™" data-id="element-214" data-mp="b5huyo5mkubf" />
        <ul className="mt-4 grid grid-cols-2 gap-y-2 gap-x-3" data-id="element-215" data-mp="b2vo6qqk6iu9">
          {trustPoints.map(point => <li key={point} className="flex items-start gap-1.5 text-[11px] font-semibold leading-tight text-white/70 sm:text-xs" data-id="element-216" data-mp="1vko3b0j5gqdh">
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-teal-300" aria-hidden="true" data-id="element-217" data-mp="25eembpwic8ls" />
              {point}
            </li>)}
        </ul>
      </div>
    </section>;
}